module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-wishlist-ES.52fad31.png";